import { render } from "./ListeGenre.vue?vue&type=template&id=667016ca&ts=true"
import script from "./ListeGenre.vue?vue&type=script&lang=ts"
export * from "./ListeGenre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__